import script from "./popupTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./popupTitle.vue?vue&type=script&setup=true&lang=js"

import "./popupTitle.vue?vue&type=style&index=0&id=1a97cf62&lang=scss&scoped=true"

import exportComponent from "/Users/zhuweiyun/Desktop/zwy/vue3-天空之城/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a97cf62"]])

export default __exports__